<template>
  <!--<div class="home">-->
    <!--&lt;!&ndash;<img alt="Vue logo" src="../assets/logo.png">&ndash;&gt;-->
    <!---->
  <!--</div>-->
  <HelloWorld />
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import HelloWorld from '@/components/AccumulatedTemperaturePrediction.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
